import React, { Component } from 'react';

class ThemeInputComp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            theme: {
                themeID: props.myTheme ? props.myTheme.themeID : -1,
                templateID: props.myTheme ? props.myTheme.templateID : -1,
                layoutThemeCode : props.layoutThemeCode,
                keypadThemeCode : props.codeItem.code,
                sort: props.sort,
                defaultYN: props.default ? 'Y' : 'N',
                themeFiles: '',
                valueChange: false,
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            this.setState({
                theme: {
                    ...this.state.theme,
                    themeID: this.props.myTheme ? this.props.myTheme.themeID : -1,
                    templateID: this.props.myTheme ? this.props.myTheme.templateID : -1,
                }
            });
        }
    }

    handleFileChange = (e) => {
        if (e.target.files[0]){
            if(this.handleExtCheck(e.target.files[0])) {
                this.setState({
                    theme: {
                        ...this.state.theme,
                        [e.target.name]: e.target.files[0] ? e.target.files[0] : this.state.theme.themeFiles,
                        valueChange: true,
                    }
                }, () => { this.props.appendTheme(this.state.theme);});
            }
        }
    };

    // themeFiles의 확장자 체크
    handleExtCheck = (themeFiles) => {
        let extCheck = false;
        let themeFilesExt = (themeFiles.name.substr(-4).toUpperCase() || "");
        if (themeFilesExt === ".JPG" || themeFilesExt === ".PNG") {
            extCheck = true;
        }

        return extCheck;
    };

    render() {
        return (
            <div className="row">
                <div className="contents-mod-title col-lg-2 col-md-2 col-sm-4 col-4">{this.props.codeItem.name}{this.props.default && <span className="text-color-red">*</span>}</div>
                <div className="text-align-left col-lg-10 col-md-10 col-sm-8 col-8">
                    <label className="w100per">
                        <input className="contents-input-file" type="file" name="themeFiles" onChange={this.handleFileChange}/>
                        <div className="contents-input-file-name">{(this.state.theme.themeFiles && this.state.theme.themeFiles.name) || (this.props.myTheme && this.props.myTheme.originFileName) || "JPG,PNG만 가능"}</div>
                        <div className="contents-input-file-button" style={{width : "80px"}}>첨부하기</div>
                    </label>
                </div>
            </div>
        )
    }
}

export default ThemeInputComp;